import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const OrgHideRepostedListingsModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "HideRepostedListingsModalContainer" */
      './OrgHideRepostedListingsModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
